// extracted by mini-css-extract-plugin
export var postNavigation = "PostNavigation-module--postNavigation--Jl+q0";
export var prevBtn = "PostNavigation-module--prevBtn--oofll";
export var btnTitle = "PostNavigation-module--btnTitle--xC1Th";
export var nextBtn = "PostNavigation-module--nextBtn--F30sF";